function getDuration(seconds) {
  const hs = Math.floor(seconds / 60 / 60),
    mins = Math.floor((seconds - hs * 60 * 60) / 60),
    secs = seconds - (mins * 60 + hs * 60 * 60);

  const normalizeHS = hs < 10 ? `0${hs}` : hs,
    normalizeMins = mins < 10 ? `0${mins}` : mins,
    normalizeSecs = secs < 10 ? `0${secs}` : secs;

  if (hs <= 0) return `${normalizeMins}:${normalizeSecs}`;

  return `${normalizeHS}:${normalizeMins}:${normalizeSecs}`;
}

export default getDuration;
